import { AbstractComponent } from '@/utils/sections/abstract-component';
import { register } from '@/utils/sections/registration';
import { captureException } from '@sentry/browser';

export class NzxWidget extends AbstractComponent {
  init() {
    this.dateEl = this.el.querySelector('[data-nzx-date]');
    this.dataEl = this.el.querySelector('[data-nzx-data]');
    this.valueEl = this.el.querySelector('[data-nzx-value]');

    fetch('/api/v1/nzx/load', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.dateEl.innerHTML = data.date;
        this.dataEl.classList.add(`is-${data.direction}`);
        this.valueEl.innerHTML = data.current;

        this.el.classList.remove('is-loading');
      })
      .catch((err) => captureException(err));
  }
}

register('nzx-widget', NzxWidget);
